import React from "react";

const Container = ({ fullWidth = false, children }) => {
  return (
    <div
      className={`w-full mx-auto bg-white rounded-[20px] p-8 ${
        !fullWidth ? "max-w-[475px]" : ""
      }`}
    >
      {children}
    </div>
  );
};

export default Container;
